 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER11 from '@/components/Chapter1-1'
 import CHAPTER12 from '@/components/Chapter1-2'
 import CHAPTER13 from '@/components/Chapter1-3'
 import CHAPTER14 from '@/components/Chapter1-4'
 import CHAPTER15 from '@/components/Chapter1-5'
 import CHAPTER16 from '@/components/Chapter1-6'
 import CHAPTER17 from '@/components/Chapter1-7'
 import CHAPTER18 from '@/components/Chapter1-8'
 import CHAPTER19 from '@/components/Chapter1-9'
 import CHAPTER110 from '@/components/Chapter1-10'
 import CHAPTER111 from '@/components/Chapter1-11'
 import CHAPTER112 from '@/components/Chapter1-12'
 import CHAPTER113 from '@/components/Chapter1-13'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER21 from '@/components/Chapter2-1'
 import CHAPTER22 from '@/components/Chapter2-2'
 import CHAPTER23 from '@/components/Chapter2-3'
 import CHAPTER24 from '@/components/Chapter2-4'
 import CHAPTER25 from '@/components/Chapter2-5'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER31 from '@/components/Chapter3-1'
 import CHAPTER32 from '@/components/Chapter3-2'
 import CHAPTER33 from '@/components/Chapter3-3'
 import CHAPTER34 from '@/components/Chapter3-4'
 import CHAPTER35 from '@/components/Chapter3-5'
 import CHAPTER36 from '@/components/Chapter3-6'
 import CHAPTER37 from '@/components/Chapter3-7'
 import CHAPTER38 from '@/components/Chapter3-8'
 import CHAPTER39 from '@/components/Chapter3-9'
 import CHAPTER310 from '@/components/Chapter3-10'
 import CHAPTER311 from '@/components/Chapter3-11'
 import CHAPTER312 from '@/components/Chapter3-12'
 import CHAPTER313 from '@/components/Chapter3-13'
 import CHAPTER314 from '@/components/Chapter3-14'
 import CHAPTER315 from '@/components/Chapter3-15'
 import CHAPTER316 from '@/components/Chapter3-16'
 import CHAPTER317 from '@/components/Chapter3-17'
 import CHAPTER318 from '@/components/Chapter3-18'
 import CHAPTER319 from '@/components/Chapter3-19'
 import CHAPTER320 from '@/components/Chapter3-20'
 import CHAPTER321 from '@/components/Chapter3-21'
 import CHAPTER322 from '@/components/Chapter3-22'
 import CHAPTER323 from '@/components/Chapter3-23'
 import CHAPTER324 from '@/components/Chapter3-24'
 import CHAPTER325 from '@/components/Chapter3-25'
 import CHAPTER326 from '@/components/Chapter3-26'
 import CHAPTER327 from '@/components/Chapter3-27'
 import CHAPTER328 from '@/components/Chapter3-28'
 import CHAPTER329 from '@/components/Chapter3-29'
 import CHAPTER330 from '@/components/Chapter3-30'
 import CHAPTER331 from '@/components/Chapter3-31'
 import CHAPTER332 from '@/components/Chapter3-32'
 import CHAPTER333 from '@/components/Chapter3-33'
 import CHAPTER334 from '@/components/Chapter3-34'
 import CHAPTER335 from '@/components/Chapter3-35'
 import CHAPTER336 from '@/components/Chapter3-36'
 import CHAPTER337 from '@/components/Chapter3-37'
 import CHAPTER338 from '@/components/Chapter3-38'
 import CHAPTER339 from '@/components/Chapter3-39'
 import CHAPTER340 from '@/components/Chapter3-40'
 import CHAPTER341 from '@/components/Chapter3-41'
 import CHAPTER342 from '@/components/Chapter3-42'
 import CHAPTER343 from '@/components/Chapter3-43'
 import CHAPTER344 from '@/components/Chapter3-44'
 import LOVE_2 from '@/components/love_2'
 import CONVERSION_CHARTS from '@/components/Conversion_charts'
 import ABOUT_AUTHOR from '@/components/About_author'
 import SUPPLIERS from '@/components/Suppliers'
 import COPYRIGHT from '@/components/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/Chapter1-1",
 			"name" : "Chapter1-1",
 			"component" : CHAPTER11
 		},
 		{
 			"path" : "/Chapter1-2",
 			"name" : "Chapter1-2",
 			"component" : CHAPTER12
 		},
 		{
 			"path" : "/Chapter1-3",
 			"name" : "Chapter1-3",
 			"component" : CHAPTER13
 		},
 		{
 			"path" : "/Chapter1-4",
 			"name" : "Chapter1-4",
 			"component" : CHAPTER14
 		},
 		{
 			"path" : "/Chapter1-5",
 			"name" : "Chapter1-5",
 			"component" : CHAPTER15
 		},
 		{
 			"path" : "/Chapter1-6",
 			"name" : "Chapter1-6",
 			"component" : CHAPTER16
 		},
 		{
 			"path" : "/Chapter1-7",
 			"name" : "Chapter1-7",
 			"component" : CHAPTER17
 		},
 		{
 			"path" : "/Chapter1-8",
 			"name" : "Chapter1-8",
 			"component" : CHAPTER18
 		},
 		{
 			"path" : "/Chapter1-9",
 			"name" : "Chapter1-9",
 			"component" : CHAPTER19
 		},
 		{
 			"path" : "/Chapter1-10",
 			"name" : "Chapter1-10",
 			"component" : CHAPTER110
 		},
 		{
 			"path" : "/Chapter1-11",
 			"name" : "Chapter1-11",
 			"component" : CHAPTER111
 		},
 		{
 			"path" : "/Chapter1-12",
 			"name" : "Chapter1-12",
 			"component" : CHAPTER112
 		},
 		{
 			"path" : "/Chapter1-13",
 			"name" : "Chapter1-13",
 			"component" : CHAPTER113
 		},
 		{
 			"path" : "/Chapter2",
 			"name" : "Chapter2",
 			"component" : CHAPTER2
 		},
 		{
 			"path" : "/Chapter2-1",
 			"name" : "Chapter2-1",
 			"component" : CHAPTER21
 		},
 		{
 			"path" : "/Chapter2-2",
 			"name" : "Chapter2-2",
 			"component" : CHAPTER22
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js